import { render, staticRenderFns } from "./MbSubscriptionPage.vue?vue&type=template&id=7677e477&scoped=true&"
import script from "./MbSubscriptionPage.vue?vue&type=script&lang=js&"
export * from "./MbSubscriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./MbSubscriptionPage.vue?vue&type=style&index=0&id=7677e477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7677e477",
  null
  
)

export default component.exports